<div class="container-fluid glb-popup">
  <h2>{{ formTitle }}</h2>
  <p-toast [style]="{ marginTop: '80px' }"> </p-toast>
  <p-confirmDialog
    header="Confirmation"
    icon="pi pi-exclamation-triangle"
  ></p-confirmDialog>

  <button
    mat-icon-button
    [mat-dialog-close]="true"
    style="float: right; top: -50px; background-color: transparent"
    >
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr />
  <div [formGroup]="form1" class="forms w-100 d-block">
    <div class="row m-0">
      <div class="col-lg-12">
        @if (formAlert) {
          <div class="w-100 mb-3">
            <div
              class="w-100"
            style="
              text-align: center;
              background-color: yellow;
              padding: 5px;
              margin-bottom: 15px;
            "
              >
              <p>
                <b>{{ formAlert }}</b>
              </p>
            </div>
          </div>
        }
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3"
          ><input
          formControlName="firstName"
          id="firstName"
          type="text"
          pInputText
          /><label for="firstName">First Name</label
          >@for (validation of validationMessages.firstName; track validation) {
          <span
            >@if (
            (form1.get('firstName').hasErrorvalidation.type &&
            form1.get('firstName').dirty) ||
            form1.get('firstName').touched
            ) {
            <small
              class="p-invalid"
              >{{ validation.message }}</small
              >
              }</span
              >
              }</span
              >
            </div>

            <div class="col-lg-6">
              <span class="p-float-label required-field w-100 mb-3"
                ><input
                formControlName="lastName"
                id="lastName"
                type="text"
                pInputText
                /><label for="lastName">Last Name</label
                >@for (validation of validationMessages.lastName; track validation) {
                <span
                  >@if (
                  (form1.get('lastName').hasErrorvalidation.type &&
                  form1.get('lastName').dirty) ||
                  form1.get('lastName').touched
                  ) {
                  <small
                    class="p-invalid"
                    >{{ validation.message }}</small
                    >
                    }</span
                    >
                    }</span
                    >
                  </div>

                  <div class="col-lg-6">
                    <span class="p-float-label w-100 mb-3">
                      <p-dropdown
                        class="w-100"
                        [options]="emailRecipientTypes"
                        formControlName="emailRecipientType"
                        optionLabel="name"
                        optionValue="value"
                        placeholder="emailRecipientType"
                      ></p-dropdown>
                      <label for="emailRecipientType">Email Recipient Type</label>
                      @for (validation of validationMessages.emailRecipientType; track validation) {
                        <span>
                          @if (
                            (form1.get('emailRecipientType').hasErrorvalidation.type &&
                            form1.get('emailRecipientType').dirty) ||
                            form1.get('emailRecipientType').touched
                            ) {
                            <small
                              class="p-invalid"
                              >{{ validation.message }}
                            </small>
                          }
                        </span>
                      }
                    </span>
                  </div>

                  <div class="col-lg-6">
                    <span class="p-float-label required-field w-100 mb-3"><input formControlName="email" id="email" type="text" pInputText/><label for="email">Email</label>@for (validation of validationMessages.email; track validation) {
                    <span>@if (
                      (form1.get('email').hasErrorvalidation.type &&
                      form1.get('email').dirty) ||
                      form1.get('email').touched
                      ) {
                      <small class="p-invalid">{{ validation.message }}</small>
                    }</span>
                  }</span>
                </div>

                <div class="col-lg-6">
                  <span class="p-float-label required-field w-100 mb-3"
                    ><input
                    formControlName="mobileCountryCode"
                    id="mobileCountryCode"
                    type="text"
                    pInputText
                    /><label for="mobileCountryCode">Mobile Country Code</label
                    >@for (validation of validationMessages.mobileCountryCode; track validation) {
                    <span
                      >@if (
                      (form1.get('mobileCountryCode').hasErrorvalidation.type &&
                      form1.get('mobileCountryCode').dirty) ||
                      form1.get('mobileCountryCode').touched
                      ) {
                      <small
                        class="p-invalid"
                        >{{ validation.message }}</small
                        >
                        }</span
                        >
                        }</span
                        >
                      </div>


                      <div class="col-lg-4">
                        <span class="p-float-label required-field w-100 mb-3">
                          <p-dropdown class="w-100" [options]="countries" formControlName="mobileCountryCode" optionLabel="name"
                          optionValue="dial" placeholder="Country Code"></p-dropdown>
                          <label for="mobileCountryCode">Country</label>
                          @for (validation of validationMessages.mobileCountryCode; track validation) {
                            <span>
                              @if (form1.get('mobileCountryCode').hasError(validation.type) && (form1.get('mobileCountryCode').dirty || form1.get('mobileCountryCode').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </span>
                      </div>


                      <div class="col-lg-6">
                        <span class="p-float-label required-field w-100 mb-3">
                          <!-- <p-inputMask formControlName="mobileNum" id="mobileNum" mask="(999) 999-9999" type="text">
                        </p-inputMask> -->
                        <input formControlName="mobileNum" id="mobileNum" type="text" pInputText>
                        <label for="mobileNum">Mobile Number</label>
                        @for (validation of validationMessages.mobileNum; track validation) {
                          <span>
                            @if (form1.get('mobileNum').hasError(validation.type) && (form1.get('mobileNum').dirty || form1.get('mobileNum').touched)) {
                              <small class="p-invalid"
                                >{{validation.message}}
                              </small>
                            }
                          </span>
                        }
                      </span>
                    </div>

                  </div>
                </div>
                <hr />
                <div class="row m-0">
                  <div class="col-lg-12">
                    <div class="btn-group">
                      <div class="button-group">
                        @if (msgRecipientId) {
                          <button pButton class="btn-delete p-button-outlined p-button-danger"
                          (click)="onFormDelete()">Delete</button>
                        }
                      </div>

                      <div class="button-group">
                        <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
                        @if (!msgRecipientId) {
                          <button pButton class="btn-addt p-button" (click)="formAdd()">Add</button>
                        }

                        @if (msgRecipientId) {
                          <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update</button>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
